module.exports = __webpack_public_path__ + "static/media/0.e2ada665.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/0.png
// module id = 925
// module chunks = 0